import { createContext, useContext } from 'react';

import type { SidebarMode } from '../../conversationSidebar.types';

export const SidebarModeContext = createContext<SidebarMode>('default');

export const useSidebarMode = (): SidebarMode => useContext(SidebarModeContext);
